// Родителю img.avatar_img нужен класс avatar_img_span (стили аватара).
// Раньше каждая задача сама обходила весь документ после монтирования:
// N задач на экране — N полных обходов DOM (на выдаче поиска это вешало
// страницу). Теперь вызовы в пределах кадра схлопываются в один обход.
let scheduled = false;

function run() {
  scheduled = false;
  document.querySelectorAll(".avatar_img").forEach((img) => {
    if (img.parentNode) img.parentNode.classList.add("avatar_img_span");
  });
}

export default function markAvatarSpans() {
  if (scheduled) return;
  scheduled = true;
  if (typeof window.requestAnimationFrame == "function") {
    window.requestAnimationFrame(run);
  } else {
    setTimeout(run, 0);
  }
}
